import { render } from "./SubpageOnlineBooking.vue?vue&type=template&id=4244b132"
import script from "./SubpageOnlineBooking.vue?vue&type=script&lang=js"
export * from "./SubpageOnlineBooking.vue?vue&type=script&lang=js"

import exportComponent from "/__w/system/system/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__